import React from 'react';
import GenericModulePage from '../../components/generic/GenericModulePage';
import { initializeModule } from '../../utils/configInit';
import { applicationSettingConfig } from './applicationSettingConfig';
import { createApplicationSettingValidationSchema } from './applicationSettingValidation';

/**
 * Initialize the ApplicationSetting module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  applicationSettingConfig,
  createApplicationSettingValidationSchema
);

/**
 * ApplicationSetting Page Component
 */
const ApplicationSettingPage = () => {
  return (
    <GenericModulePage 
      config={initializedConfig}
    />
  );
};

ApplicationSettingPage.displayName = 'ApplicationSettingPage';

export default ApplicationSettingPage;

